export const hjid_dev = 2695542;
export const hjsv_dev = 6;

export const hjid_prod = 2695543;
export const hjsv_prod = 6;

export const stepAccountDetails = "StepAccountDetails";
export const stepPaymentDetails = "StepPaymentDetails";
export const stepUserDetails = "StepUserDetails";